import { configureStore } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";
import appReducer from "./modules/app";
import publicReducer from "./modules/pubCommun";

const store = configureStore({
  reducer: {
    app: appReducer,
    public: publicReducer,
  },
});
export type IRootState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;
export const useAppSelector: TypedUseSelectorHook<IRootState> = useSelector;
export const useAppDispatch: () => AppDispatch = useDispatch;

export default store;
